//Api types
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const API_ERROR = 'API_ERROR';

export const WEB_TOKEN_OUTDATED = 'WEB_TOKEN_OUTDATED';
export const KEEP_ALIVE = 'KEEP_ALIVE';
